import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './BookingFaq.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
import { homeFaqDataSelector } from '../../../../containers/Home/redux/selectors';
import ReactDOMServer from 'react-dom/server';

const HomeBookingFaq = () => {
  
  const { faqData } = useSelector(homeFaqDataSelector);
  const renderFAQ = faqData && faqData.data && faqData.data.success && faqData.data.template && faqData.data.template.faq && faqData.data.template.faq.faq_content;
  const data = renderFAQ ? faqData.data.template.faq : [];

  return (
    <>
      {renderFAQ ?
        <S.Wrapper itemScope itemType="https://schema.org/FAQPage">
          <h3>Bus Booking FAQ</h3>
          <S.ContentWrapper>
            <ul>
              {data.faq_content.map((item, index) => {
                return (
                  <li key={index + 'busFAQHome'}                       
                  itemProp="mainEntity"
                  itemScope 
                  itemType="https://schema.org/Question">
                     <S.Question
                      itemProp="name"
                      dangerouslySetInnerHTML={{
                        __html: `${item.q}`,
                      }}
                    ></S.Question>
                    <S.Answer
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer">
                     <div itemProp="text">
                      <S.Description
                        dangerouslySetInnerHTML={{
                          __html: `${item.a}`,
                        }}
                      ></S.Description>
                      </div>
                    </S.Answer>
                  </li>
                );
              })}
            </ul>
          </S.ContentWrapper>
        </S.Wrapper>
        : <></>}
    </>
  );
};

export default HomeBookingFaq;
